import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useActionItemsStore = createStore(
  (set) => ({
    viewedAIId: {},
    recentlyViewedAIId: '',
    sorting: { ...initialSorting },
    search: '',
    lastViewedAiId: null,

    actions: {
      setAISort: (sorting) => set({ sorting }),
      setRecentlyViewedAIId: (recentlyViewedAIId) => set({ recentlyViewedAIId }),
      setLastViewedAiId: (lastViewedAiId) => set({ lastViewedAiId }),
      setActionItemsViewedId: (id) => set((state) => ({ viewedAIId: { ...state.viewedAIId, [+id]: true } })),
      setActionItemsUnViewedId: (id) =>
        set((state) => ({ viewedAIId: { ...state.viewedAIId, [+id]: false } })),
      setActionItemsSearch: (search) => set({ search }),
    },
  }),
  'ActionItemsStore',
);

export const useActionItemsStoreAction = () => useActionItemsStore((state) => state.actions);
export const selectAISort = () => useActionItemsStore((state) => state.sorting);
export const selectActionItemsViewed = () => useActionItemsStore((state) => state.viewedAIId);
export const selectActionItemsRecentlyViewed = () => useActionItemsStore((state) => state.recentlyViewedAIId);
export const selectActionItemsLastViewed = () => useActionItemsStore((state) => state.lastViewedAiId);
export const selectActionItemsSearch = () => useActionItemsStore((state) => state.search);
